import { FC } from "react";

import BranchContainer from "@app/containers/branch";

const AddBranchPage: FC = () => <BranchContainer />;

export default AddBranchPage;
